export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg
    className={className}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="fptv-logo" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00F0FF" />
        <stop offset="0.5" stopColor="#8A2BE2" />
        <stop offset="1" stopColor="#25D366" />
      </linearGradient>
    </defs>
    <rect width="40" height="40" rx="10" fill="url(#fptv-logo)" />
    <path
      d="M22 8L11 23H20L18 32L29 17H20L22 8Z"
      fill="#07080D"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const Logo = ({ onClick }) => (
  <button
    onClick={onClick}
    data-testid="nav-logo"
    className="flex items-center gap-2.5"
    aria-label="Flash Play TV — voltar ao topo"
  >
    <LogoMark className="h-9 w-9" />
    <span className="font-display text-xl font-bold uppercase tracking-wide text-white">
      Flash Play <span className="text-neon">TV</span>
    </span>
  </button>
);
